import React, { useEffect } from "react";

/**
 * JsonLd — injects a single JSON-LD <script> into <head> for the lifetime of the
 * mounted component. Removes it on unmount so SPA navigation doesn't pile up.
 */
const JsonLd = ({ id, data }) => {
  useEffect(() => {
    if (!data) return undefined;
    const scriptId = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(scriptId);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = scriptId;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const existing = document.getElementById(scriptId);
      if (existing) existing.remove();
    };
  }, [id, data]);

  return null;
};

export default JsonLd;
